import { Item } from '@radix-ui/react-accordion'
import {
  type ComponentPropsWithoutRef,
  type ElementRef,
  forwardRef,
} from 'react'
import { cn } from '#src/cn.ts'

export type AccordionItemProps = ComponentPropsWithoutRef<typeof Item>

export const AccordionItem = forwardRef<
  ElementRef<typeof Item>,
  AccordionItemProps
>(({ className, ...props }, ref) => (
  <Item ref={ref} className={cn('border-b', className)} {...props} />
))
AccordionItem.displayName = 'AccordionItem'
